import moment from 'moment-timezone';
import React from 'react';
import createTrack from 'services/actions/tracker_actions';

interface DataTableItem {
  id: number;
  title: string;
  created_at: string;
}
interface DocumentType {
  id: number;
  title: string;
  created_at: string;
}

const TITLE_GROW = 3;
const CREATED_GROW = 2;
const BUTTON_GROW = 1;

export const datatableData = (documentList: Array<DocumentType>): Array<DataTableItem> => {
  return documentList?.map((document) => {
    return {
      id: document.id,
      title: document.title,
      created_at: document.created_at,
    };
  });
};

export const datatableColumns = (
  setModalEditorOpened: React.Dispatch<React.SetStateAction<boolean>>,
  deleteDocument: (document_id: number) => void,
  setSelectedDocumentID: React.Dispatch<React.SetStateAction<number>>,
) => {
  return [
    {
      name: 'Título',
      sortable: true,
      selector: (data: DataTableItem) => data.title,
      ignoreRowClick: true,
      grow: TITLE_GROW,
      cell: (data: DataTableItem) => <div>{data.title}</div>,
    },
    {
      name: 'Criação',
      sortable: true,
      selector: (data: DataTableItem) => data.title,
      wrap: true,
      grow: CREATED_GROW,
      cell: (data: DataTableItem) => (
        <div>{moment(data.created_at).subtract(3, 'hours').format('DD/MM/YYYY [às] HH:mm')}</div>
      ),
    },
    {
      name: '',
      width: '120px',
      center: true,
      allowOverflow: true,
      grow: BUTTON_GROW,
      cell: (data: DataTableItem) => (
        <>
          <button
            type="button"
            className="btn btn-sm btn-link"
            onClick={() => {
              setSelectedDocumentID(data.id);
              setModalEditorOpened(true);
              createTrack('Dr.Licita - Visualizou peça.', { id: data.id });
            }}
          >
            <span className="material-icons">visibility</span>
          </button>
          <button
            type="button"
            className="btn btn-sm btn-link"
            onClick={() => {
              if (window.confirm('Tem certeza que deseja excluir este documento?')) {
                deleteDocument(data.id);
              }
            }}
          >
            <span className="material-icons">delete</span>
          </button>
        </>
      ),
    },
  ];
};
